import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, FormControl, OutlinedInput, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
const SearchBox = () => {
    const [query, setQuery] = useState('');
    const navigate = useNavigate();

    const handleSearch = () => {
        const q = query.trim();

        if (!q)  return;

        navigate(`/search?q=${encodeURIComponent(q)}`);
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const q = params.get('q') || '';
        setQuery(q);
    }, [window.location.search]);

    return (
        <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center">
            <FormControl sx={{ flexGrow: 1 }} variant="outlined">
                <OutlinedInput
                    id="search-box"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSearch();
                        }
                    }}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                onClick={handleSearch}
                                edge="end"
                            >
                                <SearchIcon />
                            </IconButton>
                        </InputAdornment>
                    }
                    aria-describedby="search-box-helper-text"
                    inputProps={{
                        'aria-label': 'search',
                    }}
                />
            </FormControl>
        </Box>
    );
};

export default SearchBox;